<template>
     <section class="league-name-sec m-bottom v-sheet" loading="lazy">
         <div class="remove-padding">
            <div class="favourate-game">
               <div class="fav-left">
                  <a @click="$router.back()" title="Go Back" role="button" href="javascript:void(0)"> 
                     <span class="angle-left-box"><i class="fa-solid fa-angle-left"></i></span>
                  </a>
                  <span>{{ $t('market','Markets')}}</span>
               </div>
            </div>
         </div>
      </section>
      <section class="v-tabs-market space-l" loading="lazy">
         <div class="remove-padding12">
            <div class="nav-sports">
               <ul>
                  <li class="sports-live">
                     <router-link :to="{ name: 'markets'}" class="active">
                        <img loading="lazy" src="@/assets/images/sports.webp" alt="icon-sportsbook">
                        <span>{{ $t('sportsbook','Sportsbook')}} </span>
                     </router-link>
                  </li>
                  <li class="sports-live">
                     <router-link to="/markets/live-casino">
                        <img loading="lazy" src="@/assets/images/casino-live.webp" alt="icon-live-casino">
                        <span>{{ $t('live-casino','Live Casino')}}</span>
                     </router-link>
                  </li>
                  <li class="sports-live">
                     <router-link to="/markets/live-card">
                        <img loading="lazy" src="@/assets/images/live-cards.webp" alt="icon-live-card">
                        <span>{{ $t('live-card','Live Card')}}</span>
                     </router-link>
                  </li>
               </ul>
            </div>
         </div>
      </section>
      <section class="v-tabs-group-wrapper space-l market-details-page-sec" loading="lazy">
         <div class="remove-padding">
            <div class="v-cars-tabs">
               <ul class="nav nav-tabs v-cars-play market-v-card-1" id="myTab" role="tablist">
                  <li class="nav-item sports-live" role="presentation">
                     <button class="nav-link sports-game active" id="cricket-tab" data-bs-toggle="tab" data-bs-target="#cricket" type="button" role="tab" aria-controls="cricket" aria-selected="true">
                     <img loading="lazy" src="@/assets/images/cricket.5c05f66.webp" alt="cricket">
                     <span> {{ $t('cricket','Cricket')}}</span>
                     </button>
                  </li>
                  <li class="nav-item sports-live" role="presentation">
                     <button class="nav-link sports-game" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">
                     <img loading="lazy" src="@/assets/images/soccer.webp" alt="soccer">
                     <span>{{ $t('football','Football')}}</span>
                     </button>
                  </li>
                  <li class="nav-item sports-live" role="presentation">
                     <button class="nav-link sports-game" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">
                     <img loading="lazy" src="@/assets/images/tennis.webp" alt="tennis">
                     <span>{{ $t('tennis','Tennis')}}</span>
                     </button>
                  </li>
               </ul>
               <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="cricket" role="tabpanel" aria-labelledby="cricket-tab">
                     <div class="v-cars-tabs">
                        <ul class="nav nav-tabs v-cars-play about-market-tabs" id="myTab" role="tablist">
                           <li class="nav-item sports-live " role="presentation">
                              <button class="nav-link sports-game about-head active" id="cricket-tab" data-bs-toggle="tab" data-bs-target="#cricket" type="button" role="tab" aria-controls="cricket" aria-selected="true">
                              <span class="about">{{ $t('about-market','About Markets')}}</span>
                              </button>
                           </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                           <div class="tab-pane fade show active" id="cricket" role="tabpanel" aria-labelledby="cricket-tab">
                              <div class="v-card__text market-text-area-1">
                                 <div class="white--text">
                                    <h1 class="market-head">Put your cricket knowledge to the test. Play online and earn money.</h1>
                                    <div class="cricket">
                                       <h2 class="match-heading">{{ $t('cricket','Cricket')}}:</h2>
                                       <div class="v-card__text">
                                          <div  class="play-online">Do you play cricket online? Are you an ardent fan of cricket? Are you
                                             into cricket betting? {{$siteSettings?.data?.domain_name}} is
                                             one of the most trusted
                                             sports betting and cricket betting sites. It offers
                                             you a chance to play cricket online and earn money. We offer various
                                             leagues, live matches, real-time betting and real-time winning. Start
                                             cricket betting today and earn money. At any given point, you can
                                             check live cricket betting rates, and place your bets. You can trust
                                             us with your money and we offer daily exchanges. Sign up on {{$siteSettings?.data?.domain_name}}
                                             for cricket betting online.
                                          </div>
                                          <div class="play-online">
                                             Cricket betting mainly consists placing of wagers on match winners and
                                             fancy sessions.
                                          </div>
                                       </div>
                                    </div>
                                    <hr  role="separator" aria-orientation="horizontal" class="v-divider theme--dark">
                                    <div  class="match-winner">
                                       <h2  class="match-heading">{{ $t('match-odds','Match Odds')}}:</h2>
                                       <div  class="v-card__text">
                                          <div  class="row no-gutters">
                                             <div  class="col-md-6 col-12">
                                                <div>
                                                   <div  class="play-online">
                                                      Back - Placing a back bet simply means you are staking money on
                                                      the team to win.
                                                   </div>
                                                   <div  class="play-online">
                                                      Lay - Placing a lay bet simply means you are staking money on
                                                      the team to NOT win.
                                                   </div>
                                                </div>
                                             </div>
                                             <div  class="col-md-6 col-12">
                                                <div class="odds-img-center">
                                                   <img loading="lazy" src="@/assets/images/cricket-odds.webp" alt="cricket-odds">
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <hr  role="separator" aria-orientation="horizontal" class="v-divider theme--dark">
                                    <div  class="fancy">
                                       <h2  class="match-heading">{{ $t('fancy','Fancy')}}:</h2>
                                       <div  class="v-card__text">
                                          <div  class="font-weight-bold">
                                             Fall of Wicket:
                                          </div>
                                          <div  class="row no-gutters">
                                             <div  class="col-md-6 col-12">
                                                <div >
                                                   <div  class="play-online">
                                                      Bet on when the wicket shall fall in line with the score. Chose
                                                      whether the wicket will fall within that score or not
                                                   </div>
                                                   <div  class="play-online font-italic">
                                                      **in case the wicket doesnt fall, the bets are voided**
                                                   </div>
                                                </div>
                                             </div>
                                             <div  class="col-md-6 col-12">
                                                <div class="odds-img-center">
                                                   <img loading="lazy" src="@/assets/images/cricket-fall.webp" alt="cricket-fall">
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div  class="v-card__text">
                                          <div  class="font-weight-bold">
                                             Batsman Runs:
                                          </div>
                                          <div  class="row no-gutters">
                                             <div  class="col-md-6 col-12">
                                                <div>
                                                   <div  class="play-online">
                                                      Bet on the runs a batsman shall score in an innings. The market
                                                      opens once the batsman comes on crease.
                                                   </div>
                                                </div>
                                             </div>
                                             <div  class="col-md-6 col-12">
                                                <div class="odds-img-center">
                                                   <img loading="lazy" src="@/assets/images/cricket-runs.webp" alt="cricket-runs">
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div  class="v-card__text">
                                          <div  class="font-weight-bold">
                                             Lambi Runs:
                                          </div>
                                          <div  class="row no-gutters">
                                             <div  class="col-md-6 col-12">
                                                <div >
                                                   <div  class="play-online">
                                                      Bet on the final innings score of the batting team.
                                                   </div>
                                                </div>
                                             </div>
                                             <div  class="col-md-6 col-12">
                                                <div class="odds-img-center">
                                                   <img loading="lazy" src="@/assets/images/cricket-lambi.webp" alt="cricket-lambi">
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div  class="v-card__text">
                                          <div  class="font-weight-bold">
                                             Over sessions:
                                          </div>
                                          <div  class="row no-gutters">
                                             <div  class="col-md-6 col-12">
                                                <div >
                                                   <div  class="play-online">
                                                      Bet on the score at the end of the said number of overs.
                                                   </div>
                                                </div>
                                             </div>
                                             <div  class="col-md-6 col-12">
                                                <div class="odds-img-center">
                                                   <img loading="lazy" src="@/assets/images/cricket-over.webp" alt="cricket-over">
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                     <div class="v-cars-tabs">
                        <ul class="nav nav-tabs v-cars-play about-market-tabs" id="myTab" role="tablist">
                           <li class="nav-item sports-live " role="presentation">
                              <button class="nav-link sports-game about-head active" id="cricket-tab" data-bs-toggle="tab" data-bs-target="#cricket" type="button" role="tab" aria-controls="cricket" aria-selected="true">
                              <span class="about">About Markets</span>
                              </button>
                           </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                           <div class="tab-pane fade show active" id="cricket" role="tabpanel" aria-labelledby="cricket-tab">
                              <div class="v-card__text market-football-details">
                                 <div class="white--text">
                                    <h1 class="market-head">A whole new level to your football “goals”. Play online today.</h1>
                                    <div class="cricket">
                                       <h2 class="match-heading">{{ $t('football','Football')}} :</h2>
                                       <div class="v-card__text">
                                          <div  class="play-online">On {{$siteSettings?.data?.domain_name}}, we offer comprehensive football betting on various leagues. Watch online football 
                                             games and win a lot of money. Bet on all popular leagues and even the lesser known leagues. We are one of the best betting 
                                             sites for football.  Watch online soccer games, play and win cash. Your hard earned money can be doubled in a single game
                                             if you bet right on the online football championship. Your money is safe with us and we offer daily exchanges unlike bookies
                                             who offer weekly exchanges. Sign up on {{$siteSettings?.data?.domain_name}} today!
                                          </div>
                                          <div class="play-online">
                                             Cricket betting mainly consists placing of wagers on match winners and
                                             fancy sessions.
                                          </div>
                                       </div>
                                    </div>
                                    <hr  role="separator" aria-orientation="horizontal" class="v-divider theme--dark">
                                    <div  class="match-winner">
                                       <h2  class="match-heading">{{ $t('match-odds','Match Odds')}}:</h2>
                                       <div  class="v-card__text">
                                          <div  class="row no-gutters">
                                             <div  class="col-md-6 col-12">
                                                <div>
                                                   <div  class="play-online">
                                                      Back - Placing a back bet simply means you are staking money on
                                                      the team to win.
                                                   </div>
                                                   <div  class="play-online">
                                                      Lay - Placing a lay bet simply means you are staking money on
                                                      the team to NOT win.
                                                   </div>
                                                </div>
                                             </div>
                                             <div  class="col-md-6 col-12">
                                                <div class="odds-img-center f-width">
                                                   <img loading="lazy" src="@/assets/images/soccer-odds.webp" alt="soccer-odds">
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <hr  role="separator" aria-orientation="horizontal" class="v-divider theme--dark">
                                    <div  class="fancy">
                                       <h2  class="match-heading">{{ $t('fancy','Fancy')}}:</h2>
                                       <div  class="v-card__text">
                                          <div  class="font-weight-bold">
                                             Under/ Over xyz goals :
                                          </div>
                                          <div  class="row no-gutters">
                                             <div  class="col-md-6 col-12">
                                                <div >
                                                   <div  class="play-online">
                                                      Back or lay over/ under 0.5, 1.5 upto 6.5 goals.
                                                   </div>
                                                </div>
                                             </div>
                                             <div  class="col-md-6 col-12">
                                                <div class="odds-img-center f-width-show">
                                                   <img loading="lazy" src="@/assets/images/soccer-fancy.webp" alt="soccer-fancy">
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                     <ul class="nav nav-tabs v-cars-play about-market-tabs" id="myTab" role="tablist">
                        <li class="nav-item sports-live " role="presentation">
                           <button class="nav-link sports-game about-head active" id="cricket-tab" data-bs-toggle="tab" data-bs-target="#cricket" type="button" role="tab" aria-controls="cricket" aria-selected="true">
                           <span class="about">About Markets</span>
                           </button>
                        </li>
                     </ul>
                     <div class="v-card__text market-football-details">
                        <div class="white--text">
                           <h1 class="market-head">The grass is greener on our tennis courts. Play online now.</h1>
                           <div class="cricket">
                              <h2 class="match-heading">{{ $t('tennis','Tennis')}}:</h2>
                              <div class="v-card__text">
                                 <div  class="play-online">Looking to play a table tennis online multiplayer game where you can play and earn? We’ve got you covered. Play
                                    the online tennis game or the table tennis online game and win real cash. Your
                                    money is safe with us and we offer exchange daily. You no longer have to rely on undependable bookies or other online scams. 
                                    Sign up today, and play tennis online with {{$siteSettings?.data?.domain_name}}.
                                 </div>
                                 <div  class="play-online"> Tennis betting consists primarily of match outcome and is a two horse game. Due to its volatility, 
                                    it's considered one of the most profitable avenues for bettors.
                                 </div>
                              </div>
                           </div>
                           <hr  role="separator" aria-orientation="horizontal" class="v-divider theme--dark">
                           <div  class="match-winner">
                              <h2  class="match-heading">{{ $t('match-odds','Match Odds')}}:</h2>
                              <div  class="v-card__text">
                                 <div  class="row no-gutters">
                                    <div  class="col-md-6 col-12">
                                       <div>
                                          <div  class="play-online">
                                             Back - Placing a back bet simply means you are staking money on
                                             the team to win.
                                          </div>
                                          <div  class="play-online">
                                             Lay - Placing a lay bet simply means you are staking money on
                                             the team to NOT win.
                                          </div>
                                       </div>
                                    </div>
                                    <div  class="col-md-6 col-12">
                                       <div class="odds-img-center f-width">
                                          <img loading="lazy" src="@/assets/images/tennis-odds.webp" alt="tennis-odds">
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>


</template>

<script>
export default{
    name:'Markets',
    methods: {
      goToSportsbook() {
         let isLogin = this.$store.getters.isAuthenticated;
         if(isLogin) {
               this.$router.push({ name: 'sports-book' })
         } else {
               this.$errorToast('Please Login to access Sportsbook !!');
         } 
      }
    }
}
</script>